import { useOutletContext } from 'react-router-dom';

export interface LayoutOutletContext {
  openAccountSettings: () => void;
}

// Undefined outside Layout (tests, standalone routes).
export const useLayoutOutletContext = (): LayoutOutletContext | undefined =>
  useOutletContext<LayoutOutletContext | undefined>();
